import { BigNumber } from '@ethersproject/bignumber'
import React from 'react'
import styled from 'styled-components'
import { Colors, INTEGRAL_DOCS_FIVE_URL } from '../constants'
import { useApiPools, useApiTokenPrices } from '../providers'
import { Pools } from '../providers/apiPools/model'
import { TokenPrices } from '../providers/apiTokenPrices/model'
import { RightChevron } from './icons'
import { bigNumber18DecimalsToDollars } from '../utils'

interface Props {
  className?: string
}

export function Banner({ className }: Props) {
  const apiPools = useApiPools()
  const apiTokenPrices = useApiTokenPrices()
  const { totalTradeVolumeDisplay } = getPoolTotalsDisplays(apiPools)
  const impliedLiquidityDisplay = getImpliedLiquidityDisplay(apiTokenPrices)

  return (
    <Content className={className}>
      <Stats>
        <Stat>
          <strong>Implied Liquidity</strong>
          <span>{impliedLiquidityDisplay}</span>
        </Stat>
        <Stat>
          <strong>Total Trade Volume</strong>
          <span>{totalTradeVolumeDisplay}</span>
        </Stat>
      </Stats>
      <Link href={INTEGRAL_DOCS_FIVE_URL} target="_blank">
        Learn More
        <RightChevronStyled />
      </Link>
    </Content>
  )
}

function getPoolTotalsDisplays(apiPools?: Pools) {
  let totalTradeVolumeDisplay = '-'
  if (apiPools) {
    let totalTradeVolume = BigNumber.from(0)
    Object.keys(apiPools).forEach((address: string) => {
      const pool = apiPools[address]
      totalTradeVolume = totalTradeVolume.add(pool.swapVolume)
    })
    totalTradeVolumeDisplay = bigNumber18DecimalsToDollars(totalTradeVolume)
  }
  return {
    totalTradeVolumeDisplay,
  }
}

function getImpliedLiquidityDisplay(apiTokenPrices?: TokenPrices) {
  if (apiTokenPrices && apiTokenPrices.WETH) {
    return bigNumber18DecimalsToDollars(
      BigNumber.from('2081842626596').mul(apiTokenPrices.WETH.price).div(BigNumber.from(1900))
    )
  }
  return '-'
}

const Content = styled.div`
  padding: 14px 24px;
  position: relative;
  display: flex;
  width: 100%;
  align-items: center;
  font-size: 12px;
  color: ${Colors.White};
  text-transform: uppercase;
  background: rgb(0, 0, 0);
  background: linear-gradient(90deg, rgba(0, 0, 0, 0.3) 0%, rgba(0, 0, 0, 0.2) 100%);
`

const Stats = styled.div`
  margin-right: 24px;
  display: flex;
  justify-content: space-between;
  @media (max-width: 650px) {
    margin-right: 0;
    flex-basis: 100%;
    justify-content: space-evenly;
  }
`

const Stat = styled.div`
  margin-right: 24px;
  &:last-child {
    margin-right: 0;
  }
  strong {
    margin-right: 10px;
  }
  @media (max-width: 950px) {
    strong {
      display: block;
    }
  }
  @media (max-width: 512px) {
    strong {
      font-size: 10px;
      margin-right: 0;
    }
  }
`

const Link = styled.a`
  margin-left: auto;
  display: flex;
  align-items: center;
  color: ${Colors.White};
  font-weight: bold;
  text-decoration: none;
  white-space: nowrap;
  @media (max-width: 650px) {
    display: none;
  }
`

const RightChevronStyled = styled(RightChevron)`
  margin-left: 5px;
`
